import { render } from "./AddContactForm.vue?vue&type=template&id=90ecdc4a"
import script from "./AddContactForm.vue?vue&type=script&lang=js"
export * from "./AddContactForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__